export var ITransitionCategoryTypes;
(function (ITransitionCategoryTypes) {
    ITransitionCategoryTypes["enter"] = "enter";
    ITransitionCategoryTypes["exit"] = "exit";
})(ITransitionCategoryTypes || (ITransitionCategoryTypes = {}));
export var ITransitionEffectTypes;
(function (ITransitionEffectTypes) {
    ITransitionEffectTypes["noEffect"] = "noEffect";
    ITransitionEffectTypes["right"] = "right";
    ITransitionEffectTypes["left"] = "left";
    ITransitionEffectTypes["up"] = "up";
    ITransitionEffectTypes["down"] = "down";
    ITransitionEffectTypes["fadeIn"] = "fadeIn";
    ITransitionEffectTypes["fadeOut"] = "fadeOut";
    ITransitionEffectTypes["scaleUp"] = "scaleUp";
    ITransitionEffectTypes["scaleDown"] = "scaleDown";
    ITransitionEffectTypes["spin"] = "spin";
})(ITransitionEffectTypes || (ITransitionEffectTypes = {}));
export var ITransitionTargetTypes;
(function (ITransitionTargetTypes) {
    ITransitionTargetTypes["scenes"] = "scenes";
    ITransitionTargetTypes["entities"] = "entities";
})(ITransitionTargetTypes || (ITransitionTargetTypes = {}));
